import { render, staticRenderFns } from "./ImageTextAdvPreview.vue?vue&type=template&id=2d4e1368&scoped=true&"
import script from "./ImageTextAdvPreview.vue?vue&type=script&lang=js&"
export * from "./ImageTextAdvPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextAdvPreview.vue?vue&type=style&index=0&id=2d4e1368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e1368",
  null
  
)

export default component.exports